import React from "react";
import VerifiedIcon from "@mui/icons-material/Verified";
import StarIcon from "@mui/icons-material/Star";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import CallMadeIcon from '@mui/icons-material/CallMade';
import VideocamIcon from '@mui/icons-material/Videocam';
import HomeIcon from '@mui/icons-material/Home';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { Link } from "react-router-dom";
import doctorImg from "../assets/images/doctor.png";

export default function DoctorCard({ doctor }) {
  if (!doctor) return null;

  const doctorName = doctor.doctor_name || doctor.name || "Doctor Specialist";
  const doctorImgSrc = doctor.doctor_profile_image || doctor.image || doctorImg;
  const specialityText = doctor.specializations?.map(s => s.specialization_name).join(', ') || doctor.speciality || "General Physician";
  const expText = doctor.doctor_experience ? `${doctor.doctor_experience} Exp` : (doctor.experience || "5+ Yrs Exp");
  const doctorLink = doctor.doctor_slug || doctor.doctor_id || "";

  return (
    <div className="dr_cart_home">
      <Link to={doctorLink ? `/doctordetail/${doctorLink}` : "/doctor-consultation-services"}>
        <div className="doctor-card">
          <div className="doctor-image">
            <img 
              src={doctorImgSrc} 
              alt={doctorName} 
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = doctorImg;
              }}
            />
          </div>

          <div className="doctor-info">
            <h3>{doctorName}</h3>

            <div className="doc_speciality">
              <p>{specialityText}</p> 
            </div>

            <div className="doctor-meta">
              <span className="ex_of_dr">
                <LocalHospitalIcon />
                {expText}
              </span>
              <span className="doc_rating">
                <StarIcon />
                {doctor.rating || "4.9"}
                <span> (70+ Reviews)</span>
              </span>

              <span className="verified">
                <VerifiedIcon />
                Verified
              </span>
            </div>

           <div className="doctor-tags">
              <span><VideocamIcon /> <small className="tag-text">Online</small></span>
              <span><HomeIcon /> <small className="tag-text">At Home</small></span>
              <span><LocationCityIcon /> <small className="tag-text">At Clinic</small></span>
            </div>
            
            
          </div>
          <button className="doctor-arrow"  aria-label="View doctor details">
            <CallMadeIcon />
          </button>
        </div>
      </Link>
    </div>
  );
}
